import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { pseudoEval } from '../../../fc-core/src/lib';
import { ComponentInterface } from '../../../fc-core/src/component-interface';
var IN_ALERT_RANGE = '1',
    OUT_OF_ALERT_RANGE = '2',
    ACTION_CALLJS = 'calljs',
    ACTION_SHOWANNOTATION = 'showannotation';

var AlertManager =
/*#__PURE__*/
function (_ComponentInterface) {
  _inherits(AlertManager, _ComponentInterface);

  function AlertManager() {
    var _this;

    _classCallCheck(this, AlertManager);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AlertManager).call(this)), _this.pIndex = 1, _this.linkedItems = {
      chart: {}
    };
    return _this;
  }

  _createClass(AlertManager, [{
    key: "getType",
    value: function getType() {
      return 'extension';
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'AlertManager';
    }
  }, {
    key: "configure",
    value: function configure() {
      var a,
          b,
          c,
          d = this,
          e = d.getFromEnv('dataSource'),
          f = e && e.alerts && e.alerts.alert,
          g = d.getFromEnv('number-formatter'),
          h = d.config || (d.config = {});
      if (f && f.length) for (h.alertArr = f, a = f.length, b = 0; b < a; b += 1) {
        c = f[b], c.minvalue = g.getCleanValue(c.minvalue), c.maxvalue = g.getCleanValue(c.maxvalue);
      } else h.alertArr = [];
    }
  }, {
    key: "processRTData",
    value: function processRTData(a) {
      var b,
          c,
          d,
          e,
          f,
          g,
          h,
          k = this,
          l = k.config,
          m = k.getFromEnv('number-formatter');
      if (a && a.dataset && a.dataset.length) for (d = a.dataset.length, b = 0; b < d; b += 1) {
        if (e = a.dataset[b], e.data && e.data.length) {
          if (l.datasetMap && 0 === l.datasetMap[b]) continue;

          for (f = e.data.length, c = 0; c < f; c += 1) {
            g = e.data[c], h = g && m.getCleanValue(g.value), null !== h && k._doAlert(m.getCleanValue(g.value));
          }
        }
      }
    }
  }, {
    key: "_doAlert",
    value: function _doAlert(a) {
      var b,
          c,
          d,
          e = this,
          f = e.getLinkedParent(),
          g = e.config,
          h = g.alertArr,
          i = h.length;

      for (c = 0; c < i; c += 1) {
        b = h[c], d = b.action && b.action.toLowerCase(), b.minvalue <= a && b.maxvalue >= a ? '1' === b.occuronce && b.hasOccurred || (b.hasOccurred = !0, b.state = IN_ALERT_RANGE, d === ACTION_CALLJS ? setTimeout(pseudoEval(b.param)) : d === ACTION_SHOWANNOTATION ? f.showAnnotation && f.showAnnotation(b.param) : void 0, f.fireChartInstanceEvent('AlertComplete', {
          alertValue: a,
          alertMaxValue: b.maxvalue,
          alertMinValue: b.minvalue
        })) : (d === ACTION_SHOWANNOTATION && b.state === IN_ALERT_RANGE && f.hideAnnotation && f.hideAnnotation(b.param), b.state = OUT_OF_ALERT_RANGE);
      }
    }
  }]);

  return AlertManager;
}(ComponentInterface);

export default AlertManager;